import React from 'react';
import styled from 'styled-components';
import DeleteIcon from '../../../../Icons/DeleteIcon';

const ChipUI = ({
  className,
  text,
  actionHandler,
}: {
  className?: string;
  text: string;
  actionHandler: () => void;
}) => (
  <div className={className} onClick={actionHandler}>
    <span>
      <span>{text}</span>
    </span>
    <DeleteIcon width="1rem" height="1rem" color="#0061aa" />
  </div>
);

const Chip = styled(ChipUI)(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.base};
  margin: 0 ${props.theme.spacing.small.s5} ${props.theme.spacing.small.s5} 0;
  background-color: ${props.theme.colors.white.base};
  border-radius: ${props.theme.misc.borderRadius.base};
  border: solid 1px #5aa0d5;
  > span {
    color: #0061aa;
    max-width: 15rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    > span {
      text-transform: capitalize;
      font-size: 1.1rem;
      margin-right: 0.5rem;
    }
  }
  > span {
    font-size: ${props.theme.font.small.font10};
    padding-left: ${props.theme.spacing.small.s5};
  }

`,
);

export default Chip;
